<template>
  <div>
    <div class="head-item">
      <!--шапка таргета-->
      <div class="head-item-info" v-if="$route.params.id !== '*'">
        <div class="info-side">
          <!--<div class="item-img rounded-circle" style="background-image: url(asset/Rectangle%208.png);"></div>-->

          <div class="item-title">
            <button type="button" id="sidebarCollapse" class="btn">
              <img src="asset/back.svg" alt />
            </button>
            <div v-if="editMode">
              <div class="btn-line-icon">
                <el-input v-model="newScopeName"></el-input>
                <el-button class="btn-sm btn-link" @click="editMode = false">
                  <i class="vik vik-x"></i>
                </el-button>
                <el-button class="btn-sm btn-link" @click="saveNewScopeName">
                  <i class="vik vik-save"></i>
                </el-button>
              </div>
            </div>
            <div v-else>
              <h3 style="cursor: pointer" v-bind:class="{ decoratedTitle: overTitle }" @mouseover="overTitle = true"
                @mouseleave="overTitle = false" @click="editMode = true">
                {{ name }}
              </h3>
              <span class="short-info">assets: {{ totalRows }}</span>
            </div>
          </div>
        </div>
        <div v-if="!editMode">
          <div class="btn-line">
            <button type="button" class="btn btn-primary" @click="newAssetsModalVisible = true">
              <i class="vik vik-plus"></i>Add assets
            </button>
            <el-dialog title="Add assets" :visible.sync="newAssetsModalVisible" class="modalSave">
              <el-form ref="newAssetsForm" :model="newAssetsForm">
                <el-form-item label="Records" prop="records" :rules="{
                  required: true,
                  message: 'Targets list is empty',
                  trigger: 'blur',
                }">
                  <el-input type="textarea" v-model="newAssetsForm.records" autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <button class="btn btn-primary" @click="newAssetsModalVisible = false">
                  Cancel
                </button>
                <button class="btn btn-success" @click="submitForm('newAssetsForm')">
                  <i class="vik vik-save"></i>Save
                </button>
              </span>
            </el-dialog>

            <el-popover placement="bottom" width="400" trigger="click">
              <div>
                <el-select v-model="exportFields" multiple placeholder="Select">
                  <el-option v-for="item in titles" :key="item.key" :label="item.title" :value="item.key">
                  </el-option>
                </el-select>
                <button slot="reference" type="button" class="btn btn-primary" @click="handleDownload">down</button>
              </div>

              <button slot="reference" type="button" class="btn btn-primary">
                <i class="vik vik-export"></i>Export
              </button>
            </el-popover>




          </div>
          <div class="control-side ml-auto">
            <button type="button" class="btn btn-sm btn-icon refresh" @click="handleRefresh">
              <i class="vik vik-refresh"></i>
            </button>
            <el-button type="button" class="btn btn-sm btn-icon" @click="handleRemoveScope()" :loading="deleting">
              <i class="vik vik-delete"></i>
            </el-button>
          </div>
        </div>
      </div>
      <!-- end of head -->
      <div class="filtering">
        <div class="filter-control">
          <div class="dop-options">
            <div class="checkbox-label" style>
              <label class="checkbox">
                <input type="checkbox" @change="onSelectAllChange" v-model="selectAll" />
                <span>select all</span>
              </label>
            </div>
            <div>
              <button @click="onCollapseAll" title="collapse all" class="btn-sm btn-link">
                <i class="vik vik-collapse"></i>collapse
              </button>
              <button @click="onExpandAll" title="expand all" class="btn-sm btn-link">
                <i class="vik vik-expand"></i>expand
              </button>
            </div>
          </div>
          <div class="btn-line" style="cursor: pointer; margin-left: 15px">
            <button type="button" class="btn btn-success" v-if="selectedTargets.length > 0" @click="handleGenerateTask()">
              <i class="vik vik-scan-dc">
                <span class="path1"></span>
                <span class="path2"></span> </i>Scan selected
            </button>
            <el-button type="button" class="btn btn-danger" v-if="selectedTargets.length > 0"
              @click="handleRemoveAssets()" icon="vik vik-delete" :loading="assetsAreDeleting">
              Remove selected
            </el-button>
          </div>
        </div>

        <div class="search-block">
          <div class="dual-input-group">
            <div class="search-input">
              <div class="input-icon">
                <i class="vik vik-search"></i>
              </div>
              <input v-model="filterValue" type="text" class="form-control" placeholder="filter" />
            </div>
            <el-select v-model="filterField" placeholder="Filter">
              <el-option value="Host">Host</el-option>
              <el-option :key="field" v-for="field in assetsFields" :value="field">{{ field }}</el-option>
            </el-select>

            <el-checkbox v-model="filterRegex">. *</el-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- ресурсы таргета-->
    <div class="item-container" v-for="target in assets" :key="target.host">
      <div class="resource-list">
        <div class="resource-item" v-bind:class="{
          colapsed: isCollapsed(target.host),
          active: isSelected(target.host),
        }">
          <div class="head-resourse">
            <div class="checkbox-label">
              <label class="checkbox">
                <input type="checkbox" :value="target" v-model="selectedTargets" />
                <span>{{ target.host }}
                </span>
                <router-link v-if="$route.params.id == '*'" class="el-badge item" tag="div"
                  :to="{ name: 'SingleScope', params: { id: target.scope_id } }">
                  <sup class="el-badge__content el-badge__content--undefined"
                    style="background: #dae1e3; cursor: pointer;">{{ target.scope_name }}</sup>
                </router-link>
              </label>


            </div>
            <!-- short view -->
            <div class="collapse-cont" v-if="isCollapsed(target.host)">
              <div class="value" v-for="titleItem in computedTitles" :key="titleItem.key">
                {{ titleItem.title }}
                <span>{{
                  getDataCountByTitle(target.target_info, titleItem.key)
                }}</span>

              </div>
            </div>

            <div class="control ml-auto">
              <button class="btn btn-sm btn-more" type="button">
                <i class="vik vik-more"></i>
              </button>
              <button class="btn btn-sm btn-collapse" type="button" @click="toggleCollapse(target.host)"
                v-bind:class="{ collapsed: isCollapsed(target.host) }">
                <i class="vik vik-up"></i>
              </button>
            </div>
          </div>
          <el-collapse-transition>
            <div class="resourse-cont" v-if="!isCollapsed(target.host)">

              <div v-for="title in computedTitles" class="resource-value" :key="title.key">
                <TargetColumnRender :value="target.target_info" :column="title.key" :key="title.key"></TargetColumnRender>
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </div>
    </div>
    <el-pagination background layout="prev, pager, next, sizes" :total="totalRows" :page-sizes="[10, 100, 1000, 10000]"
      :page-size="assetsPerPage" @current-change="changePage" @size-change="changePageSize"
      :hide-on-single-page="true"></el-pagination>
  </div>
</template>
<script>
import Vue from "vue";
import * as utils from "@/utils.js";
import TargetColumnRender from "@/components/internal/TargetColumnRenderV2.vue";
import { bus } from "@/bus.js";
import { getAssets, getAssetsExtra, addAssets, removeAssets, removeScope } from "@/api.js";
import _ from "lodash";

export default {
  components: {
    TargetColumnRender,
  },
  props: ["id"],
  data() {
    return {
      newScopeName: "",
      newAssetsModalVisible: false,
      editMode: false,
      overTitle: false,
      assets: [],
      name: "",
      assetsPerPage: 10,
      pageNum: 1,
      loading: false,
      deleting: false,
      assetsAreDeleting: false,
      totalRows: 0,
      imported: 0,
      list_name: "-",
      percent: 0,
      interval: 0,
      newAssetsForm: {
        records: "",
      },
      staticTitles: [
        {
          key: "host",
          title: "Host",
          dataIndex: "host",
        },
      ],
      titles: [],
      filterBy: "",
      filterField: "Host",
      filterValue: "",
      filterRegex: false,

      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.handleSelectionChange(selectedRows);
          //console.log(
          //  `selectedRowKeys: ${selectedRowKeys}`,
          //  "selectedRows: ",
          //  selectedRows
          // );
        },
        onSelect: (record, selected, selectedRows) => {
          //console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          //console.log(selected, selectedRows, changeRows);
        },
      },
      selectedTargets: [],
      collapsed: [],
      collapseState: "collapsed",
      selectAll: false,
      assetsFields: [],
      exportFields: ["Host"]
    };
  },

  mounted() {
    this.loadTargetInfo();
    this.loadTargetsFields();
    this.onCollapseAllChange();
  },
  watch: {
    $route(to, from) {
      this.pageNum = 1;
      this.assetsPerPage = 10;
      this.filterValue = "";
      this.loadTargetInfo();
      this.selectAll = false;
      this.selectedTargets = [];
    },
    filterField() {
      this.pageNum = 1;
      this.loadTargetInfo();
    },
    filterValue(v) {
      this.pageNum = 1;
      this.loadTargetInfo();
    },
  },
  computed: {
    computedTitles() {
      return this.titles.filter((record) => {
        return record.key.toLowerCase() != "host";
      });
    },
  },
  methods: {
    onCollapseAll() {
      this.collapseState = "collapsed";
      this.onCollapseAllChange();
    },
    onExpandAll() {
      this.collapseState = "expanded";
      this.onCollapseAllChange();
    },

    onCollapseAllChange() {
      if (this.collapseState == "collapsed") {
        this.assets.forEach((target) => {
          if (!this.collapsed.includes(target.host)) {
            this.collapsed.push(target.host);
          }
        });
      }
      if (this.collapseState == "expanded") {
        this.assets.forEach((target) => {
          var index = this.collapsed.indexOf(target.host);
          if (index !== -1) {
            this.collapsed.splice(index, 1);
          }
        });
      }
    },
    onSelectAllChange() {
      if (this.selectAll) {
        this.assets.forEach((target) => {
          if (!this.selectedTargets.some((t) => t.host === target.host)) {
            this.selectedTargets.push(target);
          }
        });
      } else {
        this.selectedTargets = [];
      }
    },
    toggleCollapse(domain) {
      if (this.collapsed.includes(domain)) {
        this.collapseAll = "";
        this.collapsed = this.collapsed.filter((item) => item !== domain);
      } else {
        this.collapsed.push(domain);
      }
    },
    isCollapsed(domain) {
      return this.collapsed.includes(domain);
    },
    isSelected(domain) {
      return this.selectedTargets.some((t) => t.domain === domain);
    },

    changePage(pageNum) {
      this.pageNum = pageNum;
      this.loadTargetInfo();
    },
    changePageSize(size) {
      this.assetsPerPage = size;
      this.loadTargetInfo();
    },
    saveNewScopeName() {
      let that = this;
      if (this.newScopeName.length > 0) {
        utils
          .sendPost(`/api/scopes/update/`, {
            id: that.$route.params.id,
            name: this.newScopeName,
          })
          .then((resp) => {
            that.name = this.newScopeName;
            that.editMode = false;
            that.overTitle = false;
            that.$notify({
              type: "success",
              title: "Success",
              message: "Scope renamed",
            });
          });
      } else {
        that.$notify({
          type: "error",
          title: "Error",
          message: "Scope name can't be empty",
        });
      }
    },

    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addAssets({ scope: this.$route.params.id, hosts: this.newAssetsForm.records })
            .then(() => {
              that.loading = false;
              that.$notify({
                title: "Success",
                message: "The records were added",
                type: "success",
              });

              that.newAssetsForm.records = "";
              that.newAssetsModalVisible = false;
              that.handleRefresh();
            })
            .catch((err) => {
              that.$notify({
                title: "Error",
                message: err,
                type: "error",
              });
            });

          // utils
          //   .sendPost("/api/assets/add/", this.newAssetsForm)
          //   .then((resp) => {
          //     that.loading = false;
          //     if (resp.error == null) {
          //       that.$notify({
          //         message: "Targets added",
          //         type: "success",
          //       });

          //       that.newAssetsForm.records = "";
          //       that.newAssetsModalVisible = false;
          //       that.handleRefresh();
          //     } else {
          //       that.$notify({
          //         title: "Error",
          //         message: resp.error,
          //         type: "error",
          //       });
          //     }
          //   });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSelectionChange(v) {
      this.selectedTargets = v;
    },
    handleGenerateTask() {
      let params = "#";
      let domains = "";
      domains = Array.from(this.selectedTargets, (t) => t.domain).join(",");
      params += "selectedTargets=" + domains;
      params += "&taskName=" + this.selectedTargets[0].domain + ": custom scan";
      this.$router.push({ name: "NewTask", hash: params });
    },
    handleDownload() {
      let csv = "";
      let cols = []
      for (let i in this.titles) {
        if (this.exportFields.includes(this.titles[i].title))  {
          cols.push(this.titles[i].key.toLowerCase())
        }
      }

      for (let i in cols) {
        csv += cols[i]
        if (i == cols.length - 1) {
          csv += "\n"
        } else {
          csv += ","
        }
      }

      for (let asset_idx in this.assets) {
        let fields = {}
        try {
          let ti = JSON.parse(this.assets[asset_idx].target_info);
          for (let i in ti) {

            let f = ti[i]["field_name"].split(".")[0]
            if (f) {
              f = f.toLowerCase()
            }

            if (fields.hasOwnProperty(f)) {
              fields[f].push(ti[i]["value"])
            } else {
              fields[f] = []
              fields[f].push(ti[i]["value"])
            }
          }

          csv += this.assets[asset_idx].host + ','
          for (let it in cols) {
            let t = cols[it]
            if (t == "host") continue
            if (fields.hasOwnProperty(t)) {
              let v = fields[t].join(",")

              var result = v.replace(/"/g, '""');
              if (result.search(/("|,|\n)/g) >= 0)
                result = '"' + result + '"';
              csv += result
            }
            csv += ","
          }
          csv += "\n"


        } catch (e) { console.log(e) }
      }

      console.log(csv)
      utils.generateAndDownload("assets.txt", csv);
    },

    handleRefresh() {
      this.loadTargetInfo();
      // console.log(this.$refs.assets_table.$refs.elTable);
      // this.$refs.assets_table.$refs.elTable.doLayout();
    },
    handleRemoveScope() {
      this.deleting = true;
      removeScope({ id: this.$route.params.id, name: "-" })
        .then(() => {
          this.deleting = false;
          this.$router.push({
            name: "SingleScope",
            params: { id: "*" },
          });
          bus.$emit("refresh-scopes");
        })
        .catch((err) => {
          this.$notify({
            title: "Error",
            message: err,
            type: "error",
          });
        });
    },


    handleRemoveAssets() {
      let that = this;
      this.assetsAreDeleting = true;
      removeAssets({ scope: this.$route.params.id, hosts: _.map(this.selectedTargets, 'host') })
        .then(() => {
          this.assetsAreDeleting = false;
          this.loadTargetInfo();
          this.selectAll = false;
          this.onSelectAllChange();
        })
        .catch((err) => {
          that.$notify({
            title: "Error",
            message: err,
            type: "error",
          });
        });
    },
    loadTargetInfo() {
      let that = this;
      this.loading = true;
      getAssets(
        utils.objectToString({
          scope: this.$route.params.id,
          page: this.pageNum,
          size: this.assetsPerPage,
          filter_field: this.filterField,
          filter_value: this.filterValue,
          use_regex: this.filterRegex ? "true" : "false",
        })
      ).then((res) => {
        // console.log("get ass", res);
        that.newScopeName = res.Extra.name;
        that.name = res.Extra.name;
        that.assets = res.Records;
        that.totalRows = res.Total;
        that.getTableFields();
        that.onCollapseAllChange();
      });

      /*
      fetch(
        `/api/assets/?scope=${this.$route.params.hash}&page=${this.pageNum}&size=${this.assetsPerPage}&filter_field=${this.filterField}&filter_value=${this.filterValue}&use_regex=${this.filterRegex}`
      )
        .then(function (response) {
          that.loading = false;
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            return;
          }
          response.json().then((data) => {
            if (data.error) {
              if (data.error == 404) {
                bus.$emit("refresh-assets");
              } else {
                console.log("something went wrong");
              }
              return;
            }
            that.newScopeName = data.name;
            that.name = data.name;
            that.assets = data.assets;
            that.totalRows = data.total;
            that.getTableFields();
            that.onCollapseAllChange();
          });
        })
        .catch(function (err) {
          that.$notify.error({
            title: "Error",
            message: err,
          });
        });
        */
    },
    loadTargetsFields() {
      let that = this;
      getAssetsExtra()
        .then((res) => {
          this.assetsFields = res.Records;
        })
        .catch(function (err) {
          that.$notify.error({
            title: "Error",
            message: err,
          });
        });
    },
    getTableFields() {
      // find all shared fields......
      let fields = {};
      this.titles = this.staticTitles.slice();
      for (let i in this.assets) {
        try {
          let ti = JSON.parse(this.assets[i].target_info);
          ti.forEach((targetInfo) => {
            fields[targetInfo["field_name"].split(".")[0]] = true;
          });
        } catch (e) {}
      }

      Object.keys(fields).forEach((e) => {
        this.titles.push({
          title: e,
          key: e,
          scopedSlots: { customRender: e },
        });
        this.exportFields.push(e)
      });

    },
    getDataCountByTitle(data, key) {
      // console.log(data, key);
      let total = 0;
      let parsed = JSON.parse(data);
      parsed.forEach((item) => {
        if (
          item.field_name &&
          (item.field_name == key || item.field_name.startsWith(key + "."))
        )
          total++;
      });
      return total;
    },
  },
};
</script>
<style >
.decoratedTitle {
  text-decoration: dotted;
  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-color: #97a3a6;
}

.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SingleScope.vue